import Swal from "sweetalert2"

import { customFetch } from "../helpers/fetch";
import { types } from "../types/types";
import { sendGeoPointAndGetInfo } from "./gis";


/**
 * Function that allows the show uid and name in the redux
 * @param {object} user 
 */
const login = (user) => ({
    type: types.authLogin,
    payload: user
})

/**
 * Function that allows you to login
 * @param {String} email type parameter that receives the user's email
 * @param {String} password type parameter that receives the user's password
 */
export const starLoginEmailPassword =(email,password) =>{
    return async (dispatch)=>{
        const body = await customFetch('https://datak.keraunos.co/login/',{user:email,pwd:password},'POST')
        const validations = body.find(validation=>(validation.valido))
        
        
        if(validations.valido==='SI'){
            const data = body.find(data=>( data))
            const position = body[1]

            dispatch(login({
                idsat: data.idsat,
                clima: data.clima,
                uid: data.id_cliente,
                typeUser: data.tipo,
                lat: data.lat,
                lon: data.lon,
                name: email,
                colorPoints: data.colorptos,
                nameColors: data.nombrecolor,
                nameAlerts: data.nombrealertas,
                zoom: data.zoom,
                ptws: data.tws,
                legendtws: data.legend_tws,
                valitadion: {
                    crud: data.crud,
                    ce: data.ce,
                    historic: data.historico,
                    ceHistoric: data.cehistorico,
                    report: data.reporte,
                    announcers: data.anunciadores,
                    lineLightnings: data.rayoslinet,
                    glmLightnings: data.rayosglm,
                    ligmLightnings: data.rayosligm,
                    mapControls: data.controlesmap,
                    crudCompleto: data.crudcompleto,
                    radius: data.radios,
                    shapes: data.shapes,
                    consrayos: data.consrayos,
                    tiemporeal : data.tiemporeal
                },
                position,
            }));
            dispatch(sendGeoPointAndGetInfo({pointID: data.idsat}));
        } else{
            Swal.fire('Error','Usuario/Contraseña incorrecta','error')
        }

    }
}


const logout = () => ({
    type: types.authlogout,
})

const clearData = () =>({
    type: types.printClear,
})

const clearGis = () =>({
    type: types.clearPoint,
})

export const startLogut = () => {
    return (dispatch) =>{
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logout());
        dispatch(clearData());
        dispatch(clearGis());
    }
}

// const chekingFinish = () => ({
//     type: types.authChekingFinish,
// })


